import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card, Button } from '@one-snap/sparkles';
import { Grid, Container, Popover, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Navbar from './Navbar';
import './DemoStores.css';

function DemoStores() {
  const location = useLocation();
  const navigate = useNavigate();

  const { env, audience, token } = location.state;

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);

  if (!env || !token) return null;

  const sdkOpen = Boolean(anchorEl);
  const ltoOpen = Boolean(anchorE2);

  const handleSdkPopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSdkPopoverClose = () => {
    setAnchorEl(null);
  };

  const handleLtoPopoverOpen = (event) => {
    setAnchorE2(event.currentTarget);
  };

  const handleLtoPopoverClose = () => {
    setAnchorE2(null);
  };

  const handleCardClick = (cardName) => {
    const propsToPass = {
      env,
      audience,
      token
    };
    if (cardName === 'Testing2') {
      return navigate(`/stores/sdk/products`, { state: propsToPass });
    }

    if (cardName === 'Testing3') {
      return navigate('/stores/lto/products', { state: propsToPass });
    }

    return null;
  };

  return (
    <div className="store-container-bg">
      <Navbar
        audience={audience}
        env={env}
        token={token}
        isHomeScreen
        id="navbarComponent"
      />
      <Container maxWidth="lg" style={{ marginTop: '70px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={5} style={{ marginTop: '90px' }}>
            <Card
              className="store-card"
              borderOnHover={false}
              insetBorder={false}
            >
              <div className="store-name">Snap SDK (Plugins)</div>
              <div className="store-summary store-summary-margin">
                The SDK flow offers Sales teams, Merchants, and 3rd party
                developers a seamless end-to-end experience for exploring and
                integrating the Snap SDK plugin into their systems. Current
                options available are: Shopify, Magento2, WooCommerce, and
                BigCommerce.
              </div>
              <div className="button-container">
                <Button
                  id="ltoDemoBtn"
                  className="demo-btn"
                  onClick={() => handleCardClick('Testing2')}
                >
                  See Demo
                </Button>
                <InfoOutlinedIcon
                  className="store-info-icon"
                  onMouseEnter={handleSdkPopoverOpen}
                  onMouseLeave={handleSdkPopoverClose}
                />
                <Popover
                  id="sdk-mouse-over-popover"
                  sx={{
                    pointerEvents: 'none',
                    marginTop: 2
                  }}
                  open={sdkOpen}
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                  }}
                  onClose={handleSdkPopoverClose}
                >
                  <Typography sx={{ p: 1, width: 333 }}>
                    Snap SDK is a script used for eCommerce Integrations to
                    provide access to snap checkout and marketing functions. The
                    script is primarily used by our eCommerce plugins, but it
                    may also be used by merchants directly in their on eCommerce
                    solution.
                  </Typography>
                </Popover>
              </div>
            </Card>
          </Grid>

          <Grid item xs={12} sm={5} style={{ marginTop: '90px' }}>
            <Card
              className="store-card"
              borderOnHover={false}
              insetBorder={false}
            >
              <div className="store-name">Snap-Direct LTO</div>
              <div className="store-summary">
                Direct LTO is a financing option where Snap purchases the
                merchandise, leases it to you, and, once the agreement terms are
                met, the merchandise becomes yours. This can be implemented
                across various platforms, including kiosks, waterfalls, custom
                websites, applications, and more.
              </div>
              <div className="button-container">
                <Button
                  id="ltoDemoBtn"
                  className="demo-btn"
                  onClick={() => handleCardClick('Testing3')}
                >
                  See Demo
                </Button>
                <InfoOutlinedIcon
                  className="store-info-icon"
                  onMouseEnter={handleLtoPopoverOpen}
                  onMouseLeave={handleLtoPopoverClose}
                />
                <Popover
                  id="lto-mouse-over-popover"
                  sx={{
                    pointerEvents: 'none'
                  }}
                  open={ltoOpen}
                  anchorEl={anchorE2}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                  }}
                  onClose={handleLtoPopoverClose}
                >
                  <Typography sx={{ p: 1, width: 333 }}>
                    Lease to own and loan options are available for this type of
                    integration.
                  </Typography>
                </Popover>
              </div>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default DemoStores;
